
/* eslint-disable @typescript-eslint/no-shadow */
export namespace BoUserManagementSortOrder {
  export enum BoUserManagementSortOrder {
    ASCENDING = "ASCENDING",
    DESCENDING = "DESCENDING",
  }

  export interface BoUserManagementSortOrderDTO {
    case: string;
  }

  export const fromDTO = (dto: BoUserManagementSortOrderDTO): BoUserManagementSortOrder => {
    if (dto === undefined || dto === null) {
      throw new InvalidBoUserManagementSortOrderError(
        `Invalid DTO ${dto} provided for BoUserManagementSortOrder.BoUserManagementSortOrder`
      );
    }
    switch (dto.case) {
      case "ASCENDING":
        return BoUserManagementSortOrder.ASCENDING;
      case "DESCENDING":
        return BoUserManagementSortOrder.DESCENDING;
      default:
        throw new InvalidBoUserManagementSortOrderError(
          `Case ${dto.case} is not valid case of BoUserManagementSortOrder.BoUserManagementSortOrder`
        );
    }
  };

  export const toDTO = (boUserManagementSortOrder: BoUserManagementSortOrder): BoUserManagementSortOrderDTO => {
    const enumDTO = {
      case: BoUserManagementSortOrder[boUserManagementSortOrder],
    };
    return enumDTO;
  };
}

export class InvalidBoUserManagementSortOrderError extends Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidBoUserManagementSortOrderError";
  }
}
export class InvalidBoUserManagementSortOrderAscendingError extends InvalidBoUserManagementSortOrderError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidBoUserManagementSortOrderAscendingError";
  }
}

export class InvalidBoUserManagementSortOrderDescendingError extends InvalidBoUserManagementSortOrderError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidBoUserManagementSortOrderDescendingError";
  }
}
